import React from 'react';

import data from '../../../core/data';

const Treatment = (props) => {
  return (
    <div className="treatment-wrapper">
      <div className="treatment">
        <h2>{ props.heading }</h2>
        <p>{ props.subheading }</p>
      </div>
    </div>
  )
};

const Treatments = (props) => {
  const addenum = data.phyto.uses.addenum;

  return (
    <section id="treatments" className="dark">
      <div className="container">
        <div className="heading">
          <h2>{ addenum }</h2>
        </div>
        <Treatment heading="B Clearer" subheading="Impure" />
        <Treatment heading="B Calmer" subheading="Sensitivity" />
        <Treatment heading="B Younger" subheading="Ageing" />
        <Treatment heading="B Hydrated" subheading="Dehydration" />
        <Treatment heading="B Brighter" subheading="Pigmentation" />
      </div>
    </section>
  )
};

export default Treatments;



/** WEBPACK FOOTER **
 ** ./src/components/containers/bpeel/Treatments.jsx
 **/